import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, WhatsappLogo } from "@phosphor-icons/react";
import { COMPANY, NAV_LINKS } from "../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--sifra-ink)] text-white border-t border-[var(--sifra-line-dark)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white p-1">
              <img
                src="/sifra-logo.jpeg"
                alt="Sifra Enterprises"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="leading-tight">
              <div className="font-display font-black text-xl">{COMPANY.name}</div>
              <div className="text-[10px] tracking-label uppercase text-white/60">
                We never stop working for you
              </div>
            </div>
          </div>
          <p className="text-white/70 max-w-md text-sm md:text-base leading-relaxed">
            A trusted provider of corporate IT hardware and technology solutions —
            genuine products, competitive pricing, and long-term partnerships since
            2011.
          </p>
          <a
            href={COMPANY.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-6 inline-flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 text-xs tracking-label font-semibold uppercase hover:bg-[#1EBE5D] transition-colors"
          >
            <WhatsappLogo size={16} weight="fill" />
            Chat on WhatsApp
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-label uppercase text-white/50 mb-5">
            Navigate
          </div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-white/80 hover:text-white link-underline text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-label uppercase text-white/50 mb-5">
            Reach Us
          </div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-0.5 text-white/60 shrink-0" />
              <div>
                <div className="text-white font-semibold mb-1">Registered Office</div>
                {COMPANY.offices.registered}
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-0.5 text-white/60 shrink-0" />
              <div>
                <div className="text-white font-semibold mb-1">Branch Office</div>
                {COMPANY.offices.branch}
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-0.5 text-white/60 shrink-0" />
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="footer-phone"
                className="hover:text-white"
              >
                {COMPANY.phone}
              </a>
            </li>
            {COMPANY.emails.map((e) => (
              <li key={e} className="flex items-start gap-3">
                <EnvelopeSimple size={18} className="mt-0.5 text-white/60 shrink-0" />
                <a
                  href={`mailto:${e}`}
                  data-testid={`footer-email-${e}`}
                  className="hover:text-white"
                >
                  {e}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--sifra-line-dark)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="tracking-label uppercase">Corporate IT Hardware • India</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
